// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/morgans/v1/opportunity_watch.proto (package mono.morgans.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { OpportunityActivity, OpportunityWatch } from "../../datagateway/v1/opportunity_watch_pb";
/**
 * @generated from message mono.morgans.v1.GetOpportunityWatchRequest
 */ export class GetOpportunityWatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityWatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityWatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityWatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityWatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityWatchRequest, "runtime", proto3);
_define_property(GetOpportunityWatchRequest, "typeName", "mono.morgans.v1.GetOpportunityWatchRequest");
_define_property(GetOpportunityWatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SetOpportunityWatchRequest
 */ export class SetOpportunityWatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetOpportunityWatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOpportunityWatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOpportunityWatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOpportunityWatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: bool watching = 2;
   */ _define_property(this, "watching", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOpportunityWatchRequest, "runtime", proto3);
_define_property(SetOpportunityWatchRequest, "typeName", "mono.morgans.v1.SetOpportunityWatchRequest");
_define_property(SetOpportunityWatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "watching",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListOpportunityActivityRequest
 */ export class ListOpportunityActivityRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityActivityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityActivityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityActivityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityActivityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityActivityRequest, "runtime", proto3);
_define_property(ListOpportunityActivityRequest, "typeName", "mono.morgans.v1.ListOpportunityActivityRequest");
_define_property(ListOpportunityActivityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetOpportunityActivityRequest
 */ export class GetOpportunityActivityRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityActivityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityActivityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityActivityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityActivityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityActivityRequest, "runtime", proto3);
_define_property(GetOpportunityActivityRequest, "typeName", "mono.morgans.v1.GetOpportunityActivityRequest");
_define_property(GetOpportunityActivityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetOpportunityWatchResponse
 */ export class GetOpportunityWatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityWatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityWatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityWatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityWatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityWatch watch = 1;
   */ _define_property(this, "watch", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityWatchResponse, "runtime", proto3);
_define_property(GetOpportunityWatchResponse, "typeName", "mono.morgans.v1.GetOpportunityWatchResponse");
_define_property(GetOpportunityWatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "watch",
            kind: "message",
            T: OpportunityWatch
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SetOpportunityWatchResponse
 */ export class SetOpportunityWatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetOpportunityWatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOpportunityWatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOpportunityWatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOpportunityWatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityWatch watch = 1;
   */ _define_property(this, "watch", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOpportunityWatchResponse, "runtime", proto3);
_define_property(SetOpportunityWatchResponse, "typeName", "mono.morgans.v1.SetOpportunityWatchResponse");
_define_property(SetOpportunityWatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "watch",
            kind: "message",
            T: OpportunityWatch
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListOpportunityActivityResponse
 */ export class ListOpportunityActivityResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityActivityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityActivityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityActivityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityActivityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OpportunityActivity activities = 1;
   */ _define_property(this, "activities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityActivityResponse, "runtime", proto3);
_define_property(ListOpportunityActivityResponse, "typeName", "mono.morgans.v1.ListOpportunityActivityResponse");
_define_property(ListOpportunityActivityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "activities",
            kind: "message",
            T: OpportunityActivity,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetOpportunityActivityResponse
 */ export class GetOpportunityActivityResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityActivityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityActivityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityActivityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityActivityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityActivity activity = 1;
   */ _define_property(this, "activity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityActivityResponse, "runtime", proto3);
_define_property(GetOpportunityActivityResponse, "typeName", "mono.morgans.v1.GetOpportunityActivityResponse");
_define_property(GetOpportunityActivityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "activity",
            kind: "message",
            T: OpportunityActivity
        }
    ]));
